import React, {useState} from "react"
import PropTypes from 'prop-types'
import {Box, Button, ButtonGroup, Dialog, Grid, IconButton, Toolbar, Typography} from "@mui/material"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import {ExportFile} from "src/utils/export-file"
import {DATE_FORMAT_SHOW} from "src/utils/constants"
import ButtonWithIcon from "../../../../../components/Button/Button"
import {ReactComponent as FileIcon} from "src/v2/assets/icons/file-icon.svg"
import MultiAxisChartComponent from "src/v2/components/Chart/multiaxis-chart"
import theme from "../../../../../theme/theme"
import DateIntervalButtonGroup from "src/v2/components/Date/date-interval-button-group"


const GraficoDateRangeModal = (props) => {
    const exportFile = new ExportFile()
    const [chartTitle, setChartTitle] = useState("")
    const [showDatesSelected, setShowDateSelected] = useState({
        firstDate: "",
        endDate: ""
    })
    const [chartSelected, setChartSelected] = useState(0)

    const generateChartImage = () => {
        setChartTitle(`${props.title}`)

        setTimeout(() => {
            const element = document.getElementById('chartCapture')
            exportFile.toImage(element, `${props.title}`)
            setChartTitle("")
        }, 100)
    }

    const generateCsvFile = () => {
        exportFile.toCSV(props.csvData, `${props.title}`, ";")
    }

    const showDate = (value) => {
        console.log(chartTitle)
        const {firstDate, endDate} = value

        setShowDateSelected({
            firstDate: firstDate ? firstDate.format(DATE_FORMAT_SHOW) : null,
            endDate: endDate.format(DATE_FORMAT_SHOW),
        })
    }

    const generateChartData = async () => {
        // await props.loadChartData(value)
    }

    return <Dialog
        PaperProps={{
            sx: {
                backgroundColor: theme.palette.background.chart,
            }
        }}
        fullScreen
        open={props.open}
        onClose={() => props.onClose()}>

        <Toolbar sx={{
            backgroundColor: theme.palette.background.paper,
        }}>
            <IconButton
                edge="start"
                color="inherit"
                onClick={() => props.onClose()}
                aria-label="close"
            >
                <CloseRoundedIcon/>
            </IconButton>
            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{px: 2}}
            >
                {/* Título */}
                <Grid item>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{color: "#fff"}}
                    >
                        {props.title}
                    </Typography>
                </Grid>

                {/* Botões */}
                <Grid item>
                    <Box sx={{display: "flex", gap: 1}}>
                        <ButtonWithIcon
                            icon={<FileIcon/>}
                            onClick={generateChartImage}
                        >
                            Gerar Imagem
                        </ButtonWithIcon>

                        <ButtonWithIcon
                            icon={<FileIcon/>}
                            onClick={generateCsvFile}
                        >
                            Gerar CSV
                        </ButtonWithIcon>
                    </Box>
                </Grid>
            </Grid>
        </Toolbar>

        <Box sx={{p: 4,}}>
            <Grid container direction="column" alignItems={"flex-end"} justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <DateIntervalButtonGroup callback={(value) => {
                        showDate(value)
                        generateChartData(value)
                        props.loadChartData(value)
                    }}/>
                </Grid>
                <Grid item>
                    <Typography
                        color="common.white"
                        variant="body2">
                        {`${showDatesSelected.firstDate !== null ? `${showDatesSelected.firstDate} à` : 'Exibindo até'} ${showDatesSelected.endDate}`}
                    </Typography>
                </Grid>
            </Grid>
            <br/>
            {
                props.chartData.data.length > 1 ?
                    <Grid container direction="row" alignItems={"flex-end"} justifyContent="flex-end" spacing={2}>
                        <Grid item>
                            <ButtonGroup color="primary" variant="outlined">
                                {props.chartData.data.map((option, index) => (
                                    <Button
                                        key={option.grupo}
                                        onClick={() => setChartSelected(index)}
                                        variant={chartSelected === index ? "contained" : "outlined"}
                                    >
                                        {option.grupo}
                                    </Button>
                                ))}
                            </ButtonGroup>
                        </Grid>
                    </Grid> : null
            }
            <br/>
            <Grid container direction="row" alignItems={"center"} justifyContent="flex-start" spacing={0}>
                <Grid item sm={12} md={12} xl={12}>
                    {(props.chartData.data.length === 0) ?
                        <MultiAxisChartComponent
                            id="chartCapture"
                            tension={0.0}
                            title={chartTitle}
                            xTitle={props.chartData.xTitle}
                            yTitle={props.chartData.yTitle}
                            yRightTitle={props.chartData.yRightTitle}
                            xValue={[]}
                            values={[]}/>
                        :
                        props.chartData.data.map((item, index) => (
                            <Box key={index} sx={{display: chartSelected !== index ? 'none' : 'block'}}>
                                <MultiAxisChartComponent
                                    id="chartCapture"
                                    tension={0.0}
                                    randomColor={false}
                                    title={chartTitle}
                                    xTitle={props.chartData.xTitle}
                                    yTitle={props.chartData.yTitle}
                                    yRightTitle={props.chartData.yRightTitle}
                                    xValue={item.dateList}
                                    values={[item]}/>
                            </Box>
                        ))
                    }
                </Grid>
            </Grid>

        </Box>
    </Dialog>
}

GraficoDateRangeModal.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
    loadChartData: PropTypes.func,
    chartData: PropTypes.object,
    csvData: PropTypes.array
}

export default GraficoDateRangeModal